import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function DeliveryProtectedRoute({ children }) {
  const { user, booting } = useAuth();
  const loc = useLocation();
  if (booting) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(loc.pathname)}`} replace />;
  if (user.role !== "DELIVERY_PARTNER" && user.role !== "DELIVERY_MANAGER") {
    return (
      <div className="min-h-screen grid place-items-center p-8 text-center" data-testid="not-delivery">
        <div>
          <h2 className="text-2xl font-display mb-2">Delivery access only</h2>
          <p className="text-muted-foreground text-sm mb-4">This app is for Babu Baazar delivery partners.</p>
          <a href="/" className="text-primary hover:underline text-sm">← Back to shop</a>
        </div>
      </div>
    );
  }
  return children;
}
